import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class ChallengeNotifStrategy implements INotifTextStrategy {
  public createText(activity: ActivitiesAggrigatorModel): string {
    return this.getReceiverText(activity);
  }

  private getReceiverText(activity: ActivitiesAggrigatorModel): string {
    const verb = activity?.verb;
    const data = activity?.inDirectObject?.data;
    switch (verb) {
      case ActivityVerbEnum.ChallengeObtained:
        return `شما ${data?.challenge.title} را به پایان رساندید.`;

      case ActivityVerbEnum.AchievementObtained:
        return `مدال شما ${data?.assigned.data?.subTitle ?? data.title} را گرفتید.`;

      case ActivityVerbEnum.Reminder:
        const pageCount = data?.PageCount;
        const title = data?.Title;
        return pageCount > 0
          ? `اگر ${pageCount} صفحۀ امروزت را خوانده‌ای، گزارش مطالعه‌ات را وارد کن.`
          : `${title}: اگر امروز کتابت را خوانده‌ای، گزارش مطالعه‌ات را وارد کن.`;

      case ActivityVerbEnum.ChallengeFailed:
        return 'چالش شما از دست رفت!';

      default:
        return '';
    }
  }

}
